import { jsx as _jsx } from "react/jsx-runtime";
import styles from './CardContent.module.css';
import { classNames } from '../../utils';
export const CardContent = ({ children, hasExtraPadding, className, }) => (_jsx("div", Object.assign({ className: classNames(!hasExtraPadding ? styles.root : styles.extraPadding, className) }, { children: children }), void 0));
export default CardContent;
